import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';
import { selectFolderId, selectPerson } from '../../../../store/person/person.selectors';
import { globalStore } from '../../../../../shared/shared.global-service';
import { PersonAddressEnum } from '../../../../../../../../../../packages/types/src/services/enum/person-address.enum';

@Injectable()
export class VoucherDetailSituationDpStore2 extends ComponentStoreV2Factory {
    folderId = globalStore!.selectSignal((selectFolderId));

    address = computed(() => {
        return globalStore!.selectSignal(selectPerson)()?.addresses?.find((it) => {
            return it.serviceAddress || it.type === PersonAddressEnum.ACTUAL_RESIDENCY || it.type === PersonAddressEnum.PERMANENT_RESIDENCE;
        })?.address;
    });

    contacts = computed(() => {
        return this.data.getPersonContacts()?.['items'] || [];
    });
}
